import { forwardRef } from 'react';
import styled from 'styled-components';
import TickCheckbox from '../Checkbox';
import { StyledSingleSelectOption } from './SingleSelect';
import { overflowingStyles } from '../../styles/shareableStyles';

interface IProps {
  onClick: () => void;
  label: string;
  isChecked: boolean;
  isDisabled?: boolean;
}

const StyledLabel = styled.div`
  max-width: 100%;
  ${overflowingStyles};
`;

const CheckboxDropdownOption = forwardRef<HTMLButtonElement, IProps>(
  ({ onClick, label, isChecked, isDisabled }, ref) => (
    <StyledSingleSelectOption
      ref={ref}
      onClick={onClick}
      isActive={isChecked}
      disabled={isDisabled}
    >
      <TickCheckbox
        width={14}
        height={14}
        checked={isChecked}
        disabled={isDisabled}
      />
      <StyledLabel>{label}</StyledLabel>
    </StyledSingleSelectOption>
  ),
);

export default CheckboxDropdownOption;
